module.exports = __webpack_public_path__ + "static/media/OrderReady.13880e0d.gif";